import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

/**
 * Icon-only controls in the builder dock are dense and not self-explanatory, so
 * every one of them gets a real tooltip instead of a native `title` (which is
 * slow to appear and easy to miss).
 *
 * Requires a `TooltipProvider` above it — `BuilderDock` mounts one around the
 * whole dock, so anything rendered inside is covered.
 */
export function HintTooltip({
	label,
	side = "top",
	align = "center",
	children,
}) {
	if (!label) return children;
	return (
		<Tooltip>
			<TooltipTrigger asChild>{children}</TooltipTrigger>
			<TooltipContent
				side={side}
				align={align}
				className="max-w-[240px]"
			>
				{label}
			</TooltipContent>
		</Tooltip>
	);
}
